export default __webpack_public_path__ + "static/media/event_cctv.a23b1583.svg";